import {CurrentproductPossibleDesignEntry} from "@k/js/databaseInterfaceClasses"
import {Store} from "vuex";

import {Product} from "@k/js/product"
import {ref, Ref, watch} from "vue";



export class DesignDisplayListErsteller {
    private store: Store<any>;
    public designliste: Ref<string[]>;

    public constructor(store: Store<any>) {
        this.store = store;
        watch(() => store.getters["ModelStore/getCurrentOwayoProduct"], (prod: Product | null) => {
            if (prod !== null) {
                this.createDesignDisplayListe(prod.possibleDesigns)
            }
        })
        this.designliste = ref([]) as Ref<string[]>
    }

    public createDesignDisplayListe(possibleDesigns: CurrentproductPossibleDesignEntry[]) {
        this.designliste.value = possibleDesigns.filter(d => d.KonfiDiscarded === "0").map(design => design.Design);
    }
}
